import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import PreventifService, { FilterIntervention } from '../../services/PreventifService';
import { EquipementInterventionsActions, EquipementInterventionsActionType } from './action-types';
import { EQUIPEMENT_INTERVENTIONS } from './mutation-types';
import { EquipementInterventionsState } from './state';

export const actions: ActionTree<EquipementInterventionsState, RootState> = {
    async [EquipementInterventionsActions.GET_EQUIPEMENT_INTERVENTIONS](
        { commit, state }: EquipementInterventionsActionType,
        payload: FilterIntervention
    ) {
        payload.phaseIds = state.equipementId;
        payload.dateDebutPeriodeRechercheParDate = state.filterDateDebut;
        payload.dateFinPeriodeRechercheParDate = state.filterDateFin;
        commit(EQUIPEMENT_INTERVENTIONS.SET_PAGE, payload.page);
        commit(EQUIPEMENT_INTERVENTIONS.SET_ERROR, undefined);
        commit(EQUIPEMENT_INTERVENTIONS.SET_IS_LOADING, true);
        try {
            const response = await PreventifService.getModalData(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(EQUIPEMENT_INTERVENTIONS.SET_ITEMS, response.data);
                    commit(EQUIPEMENT_INTERVENTIONS.SET_SCROLL, 0);
                    commit(EQUIPEMENT_INTERVENTIONS.SET_NB_OF_PAGES, +response.headers.pages);
                    commit(EQUIPEMENT_INTERVENTIONS.SET_COUNT, +response.headers.count);
                } else {
                    commit(EQUIPEMENT_INTERVENTIONS.ADD_ITEMS, response.data);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(EQUIPEMENT_INTERVENTIONS.SET_IS_LOADING, false);
        } catch (error) {
            commit(EQUIPEMENT_INTERVENTIONS.SET_IS_LOADING, false);
            commit(EQUIPEMENT_INTERVENTIONS.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [EquipementInterventionsActions.RESET_ALL_EQUIPEMENT_INTERVENTIONS]({
        commit,
    }: EquipementInterventionsActionType) {
        commit(EQUIPEMENT_INTERVENTIONS.SET_ALL_ITEMS, []);
    },
    async [EquipementInterventionsActions.GET_ALL_EQUIPEMENT_INTERVENTIONS](
        { commit, state }: EquipementInterventionsActionType,
        payload: FilterIntervention
    ) {
        payload.dateDebutPeriodeRechercheParDate = state.filterDateDebut;
        payload.dateFinPeriodeRechercheParDate = state.filterDateFin;
        commit(EQUIPEMENT_INTERVENTIONS.SET_PAGE, payload.page);
        commit(EQUIPEMENT_INTERVENTIONS.SET_ERROR, undefined);
        commit(EQUIPEMENT_INTERVENTIONS.SET_IS_LOADING, true);
        try {
            const response = await PreventifService.getInterventionsByPhases(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(EQUIPEMENT_INTERVENTIONS.SET_ALL_ITEMS, response.data);
                    commit(EQUIPEMENT_INTERVENTIONS.SET_SCROLL, 0);
                    commit(EQUIPEMENT_INTERVENTIONS.SET_NB_OF_PAGES, +response.headers.pages);
                    commit(EQUIPEMENT_INTERVENTIONS.SET_COUNT, +response.headers.count);
                } else {
                    commit(EQUIPEMENT_INTERVENTIONS.ADD_ALL_ITEMS, response.data);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(EQUIPEMENT_INTERVENTIONS.SET_IS_LOADING, false);
        } catch (error) {
            commit(EQUIPEMENT_INTERVENTIONS.SET_IS_LOADING, false);
            commit(EQUIPEMENT_INTERVENTIONS.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
